import { Button, Grid, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useRef, useState } from 'react';
import ActionMenu from './ActionMenu';
import CardHeaderDTO from '@src/adapters/dto/card/CardHeaderDTO';
import { CardStatus } from '@src/constants/CardStatus';

interface Props {
  onEdit(): void;
  onPreview(): void;
  onArchive(): void;
  onRestore(): void;
  isEdit: boolean;
  selectedCard: CardHeaderDTO | undefined;
}

function Header({
  isEdit,
  onEdit,
  onArchive,
  onPreview,
  onRestore,
  selectedCard,
}: Props) {
  const actionRef = useRef(null);
  const [actionMenuOpen, setActionMenuOpen] = useState(false);

  const handleAction = () => {
    setActionMenuOpen((prev) => !prev);
  };

  const handleEdit = () => {
    setActionMenuOpen(false);
    onEdit();
  };

  const handleArchive = () => {
    setActionMenuOpen(false);
    onArchive();
  };

  const handleRestore = () => {
    setActionMenuOpen(false);
    onRestore();
  };

  return (
    <Grid container>
      <Grid item xs={8}>
        <Typography variant="h4">Consultants Preferences</Typography>
      </Grid>
      <Grid item xs={4}>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <Button variant="outlined">Add New</Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" onClick={onPreview}>
              Preview
            </Button>
          </Grid>
          <Grid item>
            {selectedCard && (
              <Button
                onClick={handleAction}
                variant="contained"
                color="primary"
                size="large"
                endIcon={<ArrowDropDownIcon />}
                ref={actionRef}>
                Actions
              </Button>
            )}
            {selectedCard && (
              <ActionMenu
                onRestore={handleRestore}
                onEdit={handleEdit}
                onArchive={handleArchive}
                isEdit={isEdit}
                open={actionMenuOpen}
                anchorEl={actionRef}
                status={selectedCard.status as CardStatus}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Header;
